import api from "./Api";

class AdicionalGrupoService {
  GetAdicionalGrupo(payload) {
    return api.get("/v1/adicionalGrupo/" + payload).then((response) => {
      return response.data;
    });
  }

  PostAdicionalGrupo(payload) {
    return api.post("/v1/adicionalGrupo/", payload).then((response) => {
      return response.data;
    });
  }

  PutAdicionalGrupo(payload) {
    return api.put("/v1/adicionalGrupo/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteAdicionalGrupo(payload) {
    return api.delete("/v1/adicionalGrupo/" + payload).then((response) => {
      return response.data;
    });
  }

  GetAdicionalGrupoOData(payload) {
    return api.get("/OData/AdicionalGrupo" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new AdicionalGrupoService();
